<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Ver pagos</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">Cuentas por pagar</a>
                </li>
                <li class="breadcrumb-item active">Ver pagos</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Monto</th>
                            <th>Fecha de pago</th>
                            <th>Cobrador</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="loanPayment in loanPayments" :key="loanPayment.id">
                            <td>{{mymoney(loanPayment.amount)}}</td>
                            <td>{{convertDate(loanPayment.payoutDate)}}</td>
                            <td>{{loanPayment.name}}</td>
                            <td class="btn-group mr-2" role="group" aria-label="First group">
                                <button 
                                    v-tooltip.top-center="'Ver pago'"
                                    class="btn btn-primary" 
                                    @click="showPayments(loanPayment.id)">
                                    <i class="icon-fa icon-fa-eye"/>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <sweet-modal ref="modal_payments" width="100%">
            <div class="card" v-if="LoadingView===false">
                <div class="card-header bg-primary">
                    <h5>Pagos</h5>
                </div>
                <div class="card-body">
                    <div class="row" v-for="payment in payments" :key="payment.id">
                        <template v-if="payment.namePayment==='Efectivo'">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                                </div>
                            </div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <td>Monto</td>
                                        <td>Cuenta</td>
                                        <td>Descripción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{mymoney(payment.amount)}}</td>
                                        <td>{{payment.nameAccount}}</td>
                                        <td>{{payment.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template v-if="payment.namePayment==='Cheque'">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                                </div>
                            </div>
                            <table class="table table-dark">
                                <thead>
                                    <tr>
                                        <td>Monto</td>
                                        <td>Cuenta</td>
                                        <td>No.Cheque</td>
                                        <td>Banco</td>
                                        <td>Mismo banco</td>
                                        <td>Descripción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{mymoney(payment.amount)}}</td>
                                        <td>{{payment.nameAccount}}</td>
                                        <td>{{payment.ChequeNumber}}</td>
                                        <td>{{payment.ChequeNameBank}}</td>
                                        <td>
                                            <template>
                                                <span class="btn btn-danger btn-sm"
                                                    v-if="payment.ChequeSameBank==='0'">No</span>
                                                <span class="btn btn-success btn-sm"
                                                    v-if="payment.ChequeSameBank==='1'">Si</span>
                                            </template>
                                        </td>
                                        <td>{{payment.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template v-if="payment.namePayment==='Depósito'">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                                </div>
                            </div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <td>Monto</td>
                                        <td>Cuenta</td>
                                        <td>No.Depósito</td>
                                        <td>Descripción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{mymoney(payment.amount)}}</td>
                                        <td>{{payment.nameAccount}}</td>
                                        <td>{{payment.DepositNumber}}</td>
                                        <td>{{payment.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template v-if="payment.namePayment==='Tarjeta de Crédito/Debito'">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                                </div>
                            </div>
                            <table class="table table-dark">
                                <thead>
                                    <tr>
                                        <td>Monto</td>
                                        <td>Cuenta</td>
                                        <td>No.Transacción</td>
                                        <td>Nombre de tarjeta</td>
                                        <td>Ultimos 4 dígitos de la tarjeta</td>
                                        <td>Descripción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{mymoney(payment.amount)}}</td>
                                        <td>{{payment.nameAccount}}</td>
                                        <td>{{payment.CardNumber}}</td>
                                        <td>{{payment.CardName}}</td>
                                        <td>{{payment.CardLast4digits}}</td>
                                        <td>{{payment.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <template v-if="payment.namePayment==='Transferencia'">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                                </div>
                            </div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <td>Monto</td>
                                        <td>Cuenta</td>
                                        <td>No.Transferencia</td>
                                        <td>Banco</td>
                                        <td>Mismo banco</td>
                                        <td>Descripción</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{mymoney(payment.amount)}}</td>
                                        <td>{{payment.nameAccount}}</td>
                                        <td>{{payment.TransferNumber}}</td>
                                        <td>{{payment.TransferNameBank}}</td>
                                        <td>
                                            <template>
                                                <span class="btn btn-danger btn-sm"
                                                    v-if="payment.TransferSameBank==='0'">No</span>
                                                <span class="btn btn-success btn-sm"
                                                    v-if="payment.TransferSameBank==='1'">Si</span>
                                            </template>
                                        </td>
                                        <td>{{payment.description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                </div>
            </div>
            <div class="spinner-border" role="status" v-if="LoadingView===true">
                <span class="sr-only">Loading...</span>
            </div>
        </sweet-modal>
    </div>
</template>
<script>
    import { xelacode } from '../../../helpers/xelacode'
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'

    export default {
        components: {
            SweetModal,
            SweetModalTab,
        },
        data() {
            return {
                loanPayments: [],
                payments:[],
                LoadingView:true,
            }

        },
        methods: {
            getloanPayments() {
                let vm = this;
                axios.get(`/api/admin/incomingloan/getloanPayments/${this.$route.query.id}`)
                    .then((response) => {
                        this.loanPayments = response.data;
                    }).catch((error) => {
                        console.log(error);
                    });
            },
            getloanPayments() {
                let vm = this;
                axios.get(`/api/admin/incomingloan/getloanPayments/${this.$route.query.id}`)
                    .then((response) => {
                        this.loanPayments = response.data;
                    }).catch((error) => {
                        console.log(error);
                    });
            },
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
            convertDate(date) {
                var newDate = date.split('-');
                return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
            },
            showPayments(id){
                let vm = this;
                vm.$refs.modal_payments.open();
                axios.get(`/api/admin/incomingloan/getloanTypePayments/${id}`)
                    .then((response) => {
                        vm.payments=response.data;
                        vm.LoadingView=false;
                    }).catch((error) => {
                        console.log(error);
                    });
            },
        },
        mounted() {
            this.getloanPayments();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/incomingLoan/ShowPaymentsLoan.vue